import { NgxI18nTranslationLoaderGuard, provideWithTranslations } from '@studiohyperdrive/ngx-i18n';

import { AppRoutePaths, VlaioRoutes } from '@vlaio/shared/route-paths';

import { I18nKeys } from '../i18n';

import { ProductsHomeTranslationLoader } from './translate.loader';

export const ProductsHomeRoutes: VlaioRoutes = [
	provideWithTranslations(
		{
			path: AppRoutePaths.Empty,
			loadComponent: () =>
				import('./pages/home-products/home-products.component').then((m) => m.HomeProductsPageComponent),
			canActivate: [NgxI18nTranslationLoaderGuard],
			children: [
				{
					path: AppRoutePaths.Empty,
					loadChildren: () => import('@vlaio/shared/products').then((m) => m.ProductRoutes),
					data: {
						meta: {
							title: I18nKeys.PageTitles.Offers,
							description: I18nKeys.PageDescriptions.Offers
						}
					}
				}
			]
		},
		ProductsHomeTranslationLoader
	)
];
